/**
 * WARNING: The use of `require` and `module.exports` is because this package has to remain
 * in CommonJS format. Do not change ANY files here to ES6 standards or it will break usages.
 */

"use strict";

const { isArray, arrayDifference } = require("./arrays");
const { isBoolean, isTrue } = require("./booleans");
const { fromJsonString } = require("./json");
const { getLocaleInfo } = require("./locale");
const { isNumber } = require("./numbers");
const { isObject, isNullOrEmpty, getProp } = require("./objects");
const { isString, stripHtml } = require("./strings");
const {
  getFullUrl,
  getUrlWithExtention,
  getEnvironmentFromUrl,
  environmentUrls
} = require("./urls");

module.exports = {
  arrayDifference,
  environmentUrls,
  fromJsonString,
  getEnvironmentFromUrl,
  getFullUrl,
  getLocaleInfo,
  getProp,
  getUrlWithExtention,
  isArray,
  isBoolean,
  isNullOrEmpty,
  isNumber,
  isObject,
  isString,
  stripHtml,
  isTrue
};
